import React, { useEffect, useState } from "react"
import { Button, Col, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

// Import Editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

//Import Date Picker
import "react-datepicker/dist/react-datepicker.css"
import PropTypes from "prop-types"
import FormInputText from "../../components/Common/form-input-text"
import FormInputSelect from "../../components/Common/form-input-select"
import { withTranslation } from "react-i18next"
import moment from "moment/moment"
import { MultiSelect } from "react-multi-select-component"

const EmpresaRelatorioModal = props => {
  const { empresaAgenda, isOpen, toggle, saveAgenda, isEditing, tiposRestantes} = props

  const daysOptions = [
    { label: props.t("company-report.days.option.1"), value: 1 },
    { label: props.t("company-report.days.option.2"), value: 2 }
  ]
  const [daysOfMonth, setDaysOfMonth] = useState([])
  const [empresaAgendaModal, setEmpresaAgendaModal] = useState({
    id: null,
    email: null,
    tipo: 1,
    periodo: "month",
    diaTipo: 1,
    dias: null
  })

  const daysOfWeek = [
    { label: props.t("company-report.weekday.0"), value: 0 }, { label: props.t("company-report.weekday.1"), value: 1 },
    { label: props.t("company-report.weekday.2"), value: 2 }, { label: props.t("company-report.weekday.3"), value: 3 },
    { label: props.t("company-report.weekday.4"), value: 4 }, { label: props.t("company-report.weekday.5"), value: 5 },
    { label: props.t("company-report.weekday.6"), value: 6 }
  ]

  const periodOptions = [
    { label: props.t("company-report.period.month"), value: "month" },
    { label: props.t("company-report.period.yesterday"), value: "yesterday" },
    { label: props.t("company-report.period.lastDays"), value: "lastDays" },
    { label: props.t("company-report.period.lastWeek"), value: "lastWeek" }
  ]

  const [selectedDays, setSelectedDays] = useState([])

  useEffect(() => {

    const daysMonth = getDaysOfCurrentMonth()
    setDaysOfMonth(daysMonth)

    if (empresaAgenda) {
      if (isEditing) {
        const daysSelected = empresaAgenda.dias.split(",").map(item => Number(item))
        if (empresaAgenda.diaTipo === 1) {
          setSelectedDays(daysOfWeek.filter(dayWeek => daysSelected.some(selected => selected === dayWeek.value)))
        } else {
          const daysMonth = getDaysOfCurrentMonth()
          setSelectedDays(daysMonth.filter(dayMonth => daysSelected.some(selected => selected === dayMonth.value)))
        }
      } else {
        empresaAgenda.tipo = tiposRestantes[0].value;
      }
      setEmpresaAgendaModal(empresaAgenda)
    }
  }, [empresaAgenda])


  const save = () => {
    empresaAgendaModal.dias = selectedDays.map(day => day.value).join(",")
    saveAgenda(empresaAgendaModal)
  }

  const getDaysOfCurrentMonth = () => {
    return Array.from({ length: moment().daysInMonth() }, (_, i) => ({
      label: `${i + 1}`,
      value: i + 1
    }))
  }

  const ArrowRenderer = ({ expanded }) => <span className="arrow"></span>
  const ClearRenderer = () => <span className="clear"></span>

  return (
    <React.Fragment>
      {empresaAgendaModal && (

        <Modal
          isOpen={isOpen}
          role="dialog"
          autoFocus={true}
          centered={true}
          tabIndex="-1"
          scrollable={false}
          size="xl"
          toggle={toggle}
        >
          <div className="modal-content">

            <ModalHeader toggle={toggle}>{props.t("company-report.title")}</ModalHeader>
            <ModalBody>

              <div className="outer">
                <div className="outer">
                  <Form>
                    {isEditing && (
                      <FormInputText
                        attribute="id"
                        description={props.t("company-report.id")}
                        value={empresaAgendaModal.id}
                        readOnly={true}
                        disabled={true}
                      >
                      </FormInputText>
                    )}

                    <FormInputSelect
                      attribute="tipo"
                      description={props.t("company-report.tipo")}
                      value={empresaAgendaModal.tipo}
                      setValue={(e) => setEmpresaAgendaModal({ ...empresaAgendaModal, tipo: e })}
                      options={tiposRestantes}
                      required={true}
                      disabled={isEditing || tiposRestantes.length === 1}
                    />

                    <FormInputText
                      attribute="email"
                      description={props.t("company-report.email")}
                      value={empresaAgendaModal.email}
                      setValue={(e) => setEmpresaAgendaModal({ ...empresaAgendaModal, email: e })}
                      required={true}
                    >
                    </FormInputText>

                    {/*<FormInputText*/}
                    {/*  attribute="telefone"*/}
                    {/*  description={"Telefone"}>*/}
                    {/*</FormInputText>*/}

                    <FormInputSelect
                      attribute="diaOpcao"
                      description={props.t("company-report.days.option")}
                      value={empresaAgendaModal.diaTipo}
                      setValue={(e) => {
                        const val = e !== null && e !== "" ? Number(e): ""
                        if (val !== empresaAgendaModal.diaTipo) {
                          setSelectedDays([])
                        }
                        setEmpresaAgendaModal({ ...empresaAgendaModal, diaTipo: val })
                      }
                      }
                      options={daysOptions}
                      required={true}
                    />

                    <FormGroup className="mt-3 mb-4" row>
                      <Label className="col-form-label col-lg-2">
                        {props.t("company-report.days.send")}
                      </Label>

                      <Col lg="10">

                        <MultiSelect
                          className="w-50"
                          id={"dia-multi-multi-select"}
                          name={"dia-multi-multi-select"}
                          options={empresaAgendaModal.diaTipo === 1 ? daysOfWeek : daysOfMonth}
                          value={selectedDays}
                          onChange={value => {
                            setSelectedDays(value)
                          }}
                          labelledBy="Selecione"
                          disableSearch={false}
                          overrideStrings={{
                            "allItemsAreSelected": "Todos selecionados.",
                            "clearSearch": "Limpar",
                            "clearSelected": "Deselecionar todos",
                            "noOptions": "Não há opções",
                            "search": "Pesquisar",
                            "selectAll": "Selecionar todos",
                            "selectAllFiltered": "Selecionar todos",
                            "selectSomeItems": "Selecione",
                            "create": "Criar"
                          }
                          }
                          hasSelectAll={true}
                          ClearIcon={<ClearRenderer />}
                          ClearSelectedIcon={<ClearRenderer />}
                          ArrowRenderer={ArrowRenderer}
                          disabled={false}
                        />

                      </Col>

                    </FormGroup>


                    <FormInputSelect
                      attribute="period"
                      description={props.t("company-report.period")}
                      value={empresaAgendaModal.periodo}
                      setValue={(e) => setEmpresaAgendaModal({ ...empresaAgendaModal, periodo: e })}
                      options={periodOptions}
                      required={true}
                    />

                  </Form>

                </div>
              </div>

            </ModalBody>
            <ModalFooter>
              <Button type="submit" color="primary"
                      onClick={e => save()}
                      disabled={!(empresaAgendaModal.tipo !== "" && empresaAgendaModal.email !== "" && selectedDays.length > 0 && empresaAgendaModal.diaTipo !== ""
                        && empresaAgendaModal.periodo !== null)
                      }>
                {props.t("company-report.modal.save")}
              </Button>
              <Button type="button" color="secondary" className="me-2" onClick={toggle}>
                {props.t("company-report.modal.close")}
              </Button>
            </ModalFooter>

          </div>
        </Modal>
      )}
    </React.Fragment>
  )
}

EmpresaRelatorioModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  isEditing: PropTypes.bool,
  describeTipoRelatorio: PropTypes.func,
  tiposRestantes: PropTypes.object
}

export default withTranslation()(EmpresaRelatorioModal)
